import React from 'react';

import PropertyLookupPage from 'views/Dashboard/PropertyLookupPage';

const PropertyLookupAdminView = () => <PropertyLookupPage readOnly />;

export default PropertyLookupAdminView;
